export const engagementHomeSteps = [
  {
    element: ".FoterDetailContainer",
    intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".Engagement",
    intro: `
        <h3>Engagement</h3>
        <p>Engagement has 2 features (as shown in left most pane):
       </p>
       <ol>
          <li>Community</li>
          <li>Query</li>
        </ol>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".featuredLeftPaneE",
    intro: `
        <h3>Features Group Left Pane
        Engagement has 2 features as shown:</h3>
        <ol>
        <li>Community</li>
        <li>Query</li>
        </ol>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".community",
    intro: `
        <h3>Community</h3>
        <p>Currently 'Community' feature is selected, Let's navigate through this feature</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".YourChannels  ",
    intro: `
        <h3>Your Channels</h3>
        <p>Here you will see all the channels you are part of.
        Each channel has multiple posts, you can move to any channel from here</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".postView",
    intro: `
        <h3>Post view</h3>
        <p>You will find posts here, you can scroll vertically for more posts.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".creationDetails",
    intro: `
        <h3>Creation Details</h3>
        <p>Here you will find creator details, time, topics(tags) and channel names.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".tagList",
    intro: `
        <h3>Topic (Tag) List</h3>
        <p>Here you will find the topic list and respective post count respective.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },

  {
    element: ".searchAndFilterPosts",
    intro: `
        <h3>Search and Filter Posts</h3>
        <p>You can search posts by name, tag category here. First select category, input search text and clear search icon. Through the filter Icon you can do filtering of posts. Searching and filtering can be done together or separately.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".refresh",
    intro: `
        <h3>Refresh Posts</h3>
        <p>You can refresh post lists to keep yourself updated by clicking here.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".filterPost",
    intro: `
        <h3>Filter Post</h3>
        <p>Through the filter option you can do filtering of posts based on dates. Searching and filtering can be used separately or togeather.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".clearSearchAndFilter",
    intro: `
        <h3>Clear search and filter</h3>
        <p>You can clear search and filter by clicking here.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".createPost",
    intro: `
        <h3>create Post</h3>
        <p>You can create post from here to any channel. After approval from the moderator, your posts will be visible to your peers who are in the same channel.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".prifilePic",
    intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".done",
    intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
];

export const feelDetailSteps = [
  {
    element: ".YourChannels  ",
    intro: `
        <h3>Your Channels</h3>
        <p>Here you will see all the channels you are part of.
        Each channel has multiple posts, you can move to any channel from here</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".creationDetails",
    intro: `
        <h3>Creation Details</h3>
        <p>Here you will find creator details, time, topics(tags) and channel names.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".postDesc",
    intro: `
        <h3>Post Description</h3>
        <p>This is the description provided by creator of post.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },

  {
    element: ".postImage",
    intro: `
        <h3>Post Image(s)</h3>
        <p>This section show the images of the post. Swipe horizontally to navigate through multiple images if it has.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".imagePosIndicator",
    intro: `
        <h3>Image Position Indicator</h3>
        <p>You will find current image index and total image count here.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".likesSection",
    intro: `
        <h3>Likes section</h3>
        <p>You like this post and see list of likes here.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },

  {
    element: ".commentsSection",
    intro: `
          <h3>Comments section</h3>
          <p>You can find find all the commensts from your peers for this post here. You have to edit or delete your earlier comment by clicking on your respective comment.</p>
        `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".writeComment",
    intro: `
          <h3>Write Comment</h3>
          <p>You can write comment here and send with send icon.</p>
        `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".comments",
    intro: `
        <h3>Comments</h3>
        <p>You can find the comments count for this post here.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".createPost",
    intro: `
        <h3>create Post</h3>
        <p>You can create post from here to any channel. After approval from the moderator, your posts will be visible to your peers who are in the same channel.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".prifilePic",
    intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
  {
    element: ".done",
    intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
    position: "top",
    tooltipClass: "myTooltipClass",
    highlightClass: "myHighlightClass",
  },
];

export const aboutComm =  [
    {
      element: ".FoterDetailContainer",
      intro: `
          <h3>Parent Features Bottom Pane</h3>
          <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".Engagement",
      intro: `
          <h3>Engagement</h3>
          <p>Engagement has 2 features (as shown in left most pane):
         </p>
         <ol>
            <li>Community</li>
            <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneE",
      intro: `
          <h3>Features Group Left Pane
          Engagement has 2 features as shown:</h3>
          <ol>
          <li>Community</li>
          <li>Query</li>
          </ol>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".community",
      intro: `
          <h3>Community</h3>
          <p>Currently 'Community' feature is selected, Let's navigate through this feature</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".YourChannels  ",
      intro: `
          <h3>Your Channels</h3>
          <p>Here you will see all the channels you are part of.
          Each channel has multiple posts, you can move to any channel from here</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
        element: ".channelProfile",
        intro: `
            <h3>Channel Profile</h3>
            <p>You will find channel name and its creator.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
    {
      element: ".postTab",
      intro: `
          <h3>Post tab</h3>
          <p>You will find all post(s) of your channel here.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".aboutTab",
      intro: `
          <h3>About Tab</h3>
          <p>Here you will find details of hannel information.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    
  
    {
      element: ".membersTab",
      intro: `
          <h3>Members Tab</h3>
          <p>You will find all members belonging to this channel.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".myRequests",
      intro: `
          <h3>'My Requests' Tab</h3>
          <p>You will find all your created posts which are under review or been declined by the moderator. You can edit or delete such posts from here.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
        element: ".createPost",
        intro: `
            <h3>create Post</h3>
            <p>You can create post from here to any channel. After approval from the moderator, your posts will be visible to your peers who are in the same channel.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },

    {
      element: ".prifilePic2",
      intro: `
          <h3>Your profile, B4S App layout</h3>
          <p>Access your profile Information.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done2",
      intro: `
          <h3>Awesome, you are done. 😊</h3>
          <p>Click anywhere on the screen or click on the cross icon.</p>
        `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ];